import React from 'react'
import kebabCase from 'lodash.kebabcase'
import { ReviewsSectionProps } from '@/components/organisms/ReviewsSection/types'
import { ReviewsSlider } from '@/components/molecules/ReviewsSlider/ReviewsSlider'

export function ReviewsSection({ heading, reviews }: ReviewsSectionProps) {
  return (
    <section
      className="py-24 px-20 tablet:py-64 max-w-screen-desktop mx-auto  laptop:px-90 tablet:text-center overflow-hidden"
      id={kebabCase(heading)}
    >
      <h2 className="text-headingL-mobile text-text-dark-900 font-poppins font-bold mb-24 netbook:mb-40 netbook:text-headingL max-w-4xl text-center mx-auto">
        {heading}
      </h2>
      <ReviewsSlider reviews={reviews} />
    </section>
  )
}
